import { IChargingPoint } from '@services/device'
import Modal from '@shared/innmaxUI/Modal'
import cx from 'classnames'
import { ModalBody } from 'src/components/Modal'
import ParkingSpace from './ParkingSpace'

type IParkingSpaceDetailModalProps = {
  open: boolean
  onCancel: () => void
  data: IChargingPoint
}

const ParkingSpaceDetailModal = (props: IParkingSpaceDetailModalProps) => {
  const { open, onCancel, data } = props

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={`${data.displayName}充電樁車格狀態`}
      width={800}
      footer={null}>
      <ModalBody
        style={{ paddingLeft: '10px', paddingRight: '10px' }}
        className="flex items-center">
        <div className="flex gap-8 items-center w-full ">
          {/* 左側資訊 */}
          <DetailInfos
            side="L"
            data={data?.connectors?.filter(c => c.connectorId === 2)?.[0]}
          />

          {/* 中間 ParkingSpace 元件 */}
          <div className="flex items-center justify-center">
            <ParkingSpace data={data} />
          </div>

          {/* 右側資訊 */}
          <DetailInfos
            side="R"
            data={data?.connectors?.filter(c => c.connectorId === 1)?.[0]}
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ParkingSpaceDetailModal

const DetailInfos = (props: {
  side: 'L' | 'R'
  data?: IChargingPoint['connectors'][0]
}) => {
  const { side, data } = props
  return data ? (
    <div
      className={cx('flex flex-col gap-4 text-white flex-1 break-keep', {
        'items-end mr-30': side === 'L',
        'items-start ml-30': side === 'R',
      })}>
      <div>
        <div className="text-xl font-bold mb-5 text-[#FFCC2B]">
          {data.deviceId}
        </div>
        <div className="flex gap-2">
          <span>狀態：</span>
          <span>{data.detailedStatusStr}</span>
        </div>
        <div className="flex gap-2">
          <span>車輛編號：</span>
          <span>{data.lprNo || '--'}</span>
        </div>
        <div className="flex gap-2">
          <span>電池飽和容量：</span>
          <span>
            {(data.chargingPercentage ?? -1) >= 0
              ? `${data.chargingPercentage}%`
              : '--'}
          </span>
        </div>
        <div className="flex gap-2">
          <span>目前電壓：</span>
          <span>{data.voltage ? `${data.voltage}V` : '--'}</span>
        </div>
        <div className="flex gap-2">
          <span>安培小時：</span>
          <span>{data.current ? `${data.current}A` : '--'}</span>
        </div>
        <div className="flex gap-2">
          <span>充電開始時間：</span>
          <span>{data.chargeStartAtStr}</span>
        </div>
        <div className="flex gap-2">
          <span>累積充電時間：</span>
          <span>{data.chargingDurationSecStr}</span>
        </div>
        <div className="flex gap-2">
          <span>佔用時間：</span>
          <span>{data.occupancyMinutesStr}</span>
        </div>
      </div>
    </div>
  ) : null
}
